import { getAllWards } from '@/services/api-transit/administrativeUnits';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<API.AdministrativeUnitWardV2[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(
    null,
  );
  const [valueOptions, setValueOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const fetch = async (provinceCode?: string) => {
    const params = provinceCode ? { provinceCode } : {};
    let res = data;

    console.log('fetch wards with params', params);

    if (!res?.length) {
      res = await getAllWards({ params });
      setData(res);
    } else {
      res = res.filter((item) => {
        if (provinceCode) {
          return item.provinceCode === provinceCode;
        }
        return false;
      });
    }

    setValueEnum(
      res?.reduce(
        (pre: Record<string, string>, curr: API.AdministrativeUnitWardV2) => ({
          ...pre,
          [curr.id.toString()]: curr.name,
        }),
        {},
      ),
    );
    setValueOptions(
      res?.map((item: API.AdministrativeUnitWardV2) => ({
        value: item.wardCode,
        label: item.name,
      })),
    );
  };

  const reset = () => {
    setData(null);
    setValueEnum(null);
    setValueOptions([]);
  };

  return {
    fetch,
    reset,
    data,
    valueEnum,
    valueOptions,
  };
};
